// removed by extract-text-webpack-plugin
module.exports = {"root":"root___1Fa7l","selected":"selected___2Wfc6","content":"content___15xnv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/SidebarButton/index.scss
// module id = 78
// module chunks = 0